import React, { useEffect, useState } from "react";
import "../../../../ReuseableComponents/css/ScrollToTop.css"
import { KeyboardArrowUpTwoTone } from "@mui/icons-material";
import './MinisterMessage.css';
import RestrictedImg from "../../../../image/Restricted_Img.png";

function MinisterMessage() {
    
  /////////////////scrollto top ///////////////////
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);
  return (
    <div style={{
        position: "fixed",
        bottom: "0px",
        display: "block",
        paddingTop: "8px",
        backgroundColor: "#fff",
        width: "100%",
        zIndex:1,
      }}>
        <p style={{fontSize:"11px" ,marginLeft:"6%"}} className="minister-msg" >Os dados contidos nesta página são puxados conforme apresentados no site institucional do Ministério da Saúde (<a href="https://www.gov.br/saude/pt-br/composicao/quem-e-quem" target="_blank" style={{fontSize:"11px"}}>https://www.gov.br/saude/pt-br/composicao/quem-e-quem</a>)
         </p>
         <div style={{ marginLeft: "50px" }}>
        <a title="Scroll to top" className="scroll-to-top" onClick={scrollToTop}>
          <KeyboardArrowUpTwoTone
            aria-hidden="true"
            style={{
              width: "20px",
              height: "20px",
              display: "block",
              marginLeft: "36%",
              marginRight: "58%",
              cursor: "pointer",
              border: "1px solid #fff",
              backgroundColor: "var(--bayer-dark-green)",
              color: "#fff",
              borderRadius: "10px",
              zIndex:1,
            }}
            value="Scroll to top"
          /></a>
          <img
          src={RestrictedImg}
          className="restricted-img r2"
          style={{
            width: "80px",
            height: "30px",
            float: "right",
            marginTop: "-30px",
            marginRight: "134px",
          }}
        ></img>
          </div>
      </div>
  )
}

export default MinisterMessage